<div class="floatLabel registro" [ngClass]="{'soloLectura' : disabled}">

  <div class="dropdown select" [ngClass]="{'is-filled' : multiSelect ? datoSeleccionado.length > 0 : datoSeleccionado, 'margenControl' : margenControl }" dropdown id="ddDatosOpciones" #dropdown>

    <!-- Menu -->
    <ul class="dropdown-menu" aria-labelledby="ddDatos" style="width: 100%"  id="ddDatos{{id}}" #ddMenu>

      <!-- Buscar -->
      <li class="" *ngIf="buscar">
        <div class="inputBuscardd limpieza">
          <input type="text" placeholder="Buscar" class="" id="buscar{{id}}" [(ngModel)]="busqueda"/>

          <div class="limpiarBusqueda" (click)="LimpiarBusqueda()" *ngIf="busqueda">
            <div>
              <span class="fa fa-times-circle-o"></span>
            </div>
          </div>

        </div>
      </li>

      <li *ngFor="let opcion of (multiSelect ? opcionesDisponibles : opciones) | filtro: busqueda : [displayValor]">
        <a style="background-color: {{opcion[displaybackgrountcolor]}};" class="dropdown-item" [ngClass]="{'active' : !multiSelect && opcion[valorName] === datoSeleccionado[valorName]}" (click)="SeleccionarOpcion(opcion); $event.preventDefault()"  href="">
          <span *ngIf="displayValor"> {{opcion[displayValorIcon]}} </span>
          <span>{{opcion[displayValor]}}</span>
        </a>
      </li>

    </ul>

    <!-- Botón -->
    <div class="btnDropdown ddSelect {{clasesAdicionales}}" [ngClass]="{'multi' : multiSelect, 'disabled' : disabled}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="FocusBuscar()"
         tabindex="0" id="ddBoton{{id}}" (keypress)="TeclaPresionada($event)">

      <!-- dato seleccionado -->
      <div class="texto" *ngIf="!multiSelect">
        <span *ngIf="displayValor"> {{datoSeleccionado ? datoSeleccionado[displayValorIcon] : ''}} </span>
        {{datoSeleccionado ? datoSeleccionado[displayValor] : ''}}
      </div>

      <div class="texto" *ngIf="multiSelect">
        <div class="opcionSeleccionadaDD" *ngFor="let opcion of datoSeleccionado">

          <div class="opcion">
            {{opcion[displayValor]}}
          </div>

          <div class="eliminarBtn" (click)="BorrarOpcion(opcion)">
            <span class="fa fa-times"></span>
          </div>
        </div>
      </div>

      <!-- Limpiar control -->
      <div class="btnTimes dropdownTimes" *ngIf="limpiarInput && !disabled  && datoSeleccionado && !multiSelect" (click)="LimpiarSelect()">
        <span class="fa fa-times"></span>
      </div>

      <!-- icono dd -->
      <div class="abrir">
        <span class="fa fa-caret-down"></span>
      </div>

    </div>

    <!-- Mensaje error -->
    <span *ngIf="verError" class="textoError" [hidden]="(datoSeleccionado && ((multiSelect && datoSeleccionado.length != 0) || !multiSelect)) || !errorActivo">
      {{(mensajeError ? mensajeError : 'DatoIncompeto') | translate}}
    </span>

  </div>

  <!-- Label (título del control) -->
  <label>{{titulo}}</label>

</div>
